export default "__VITE_ASSET__Bp60yJkm__"